<section id="tiny-house" class="section tiny-house">
    <div class="container">
        <h2>Las Tiny House</h2>
        <p>
            Nuestras Tiny House moviles están diseñadas para estar en armonía
            con la naturaleza. Son <strong>sustentables</strong>, pensadas para
            <strong>disfrutar y cuidar el medio ambiente</strong>, una idea
            original que te llevar a experimentar el paisaje de montaña de
            Malalcahuello, en un espacio versátil e innovador.
        </p>
        <p>
            Ambas Tiny Houses tienen nombres de aves pequeñas que
            <strong>habitan en el sector</strong> y que han sido inspiración
            para pensar en <strong>la belleza de las cosas pequeñas</strong> que
            nos rodean.
        </p>
    </div>
</section>

<style lang="scss">
    .tiny-house {
        width: 100%;
        text-align: center;
    }
</style>
